import { useEffect } from 'react';
import Actions from '../../actions/actions';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

/**
 * Custom hook to register a footnote when a component needs one
 */
const useFootnote = (id, message, variant = 'numeric') => {
  if (!['numeric', 'star'].includes(variant)) {
    variant = 'numeric';
  }

  useEffect(() => {
    Actions.registerFootnote({ id, message, variant });
    return () => Actions.deRegisterFootnote({ id });
  }, [id, message, variant]);

  const messageObj = useSelector((redux) => redux?.footnotes)?.get(id);
  return messageObj?.symbol ?? '';
};

useFootnote.propTypes = {
  id: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  variant: PropTypes.string,
};

export default useFootnote;
